module.exports = __webpack_public_path__ + "media/images/sub-menu-e5f4ef50b0d902affbfdc72ff192b163.png";